import React from 'react'
import Lottie from 'react-lottie';
import * as animationData from './LottieData/9744-sample-animation.json'

export default class LottieControl extends React.Component {

    constructor(props) {

        super(props);
        this.state = {isStopped: true, isPaused: false};

        this.customCall = this.customCall.bind(this);
    }

    customCall(){
        this.setState({ isStopped: true })
        console.log( "completamento animazione! " )
    }
    render() {
        const buttonStyle = {
            'display': 'block',
            'background': '#56a256',
            'border': '1px solid #ffffff',
            'padding': '12px 15px',
            'width': '180px',
            'borderRadius': '25px',
            'color': '#fff',
            'fontSize':'20px',
            'textTransform': 'uppercase',
            'margin': '10px auto'
        };

        const defaultOptions = {
            loop: false,
            autoplay: false,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            },
        };



        return <div>
            <Lottie options={defaultOptions}
                    height={400}
                    width={400}
                    eventListeners={
                    [{
                        eventName: 'complete',
                        callback:  this.customCall ,
                    }]
                    }
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused}/>

            <button style={buttonStyle} onClick={() => this.setState({isStopped: false})}>play</button>

        </div>
    }
}